import { render, staticRenderFns } from "./Formulaire.vue?vue&type=template&id=5bfbb4fb&"
import script from "./Formulaire.vue?vue&type=script&lang=js&"
export * from "./Formulaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports